import React, {useContext, useEffect, useState} from 'react';
import ResourceNotFound from "../notFound/ResourceNotFound";
import AccountActivatedForm from "./AccountActivatedForm";
import ActivationErrorForm from "./ActivationErrorForm";
import { useQuery } from "../../commonFunctions/commonFunctions";
import { UserActivationContext } from "./ShareStates";
import {
    getUserActivationToken,
    getQueryResult
} from "../../commonFunctions/GraphqlFunctions";

const UserActivationLandingPage = () => {
    const {updateLoginUrl} = useContext(UserActivationContext);
    const [token] = useState(useQuery().get("token"));
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [display, setDisplay] = useState("none");

    useEffect(() => {
        async function fetchData() {
            if (mountReadOnce === "none") {
                if (token !== null) {
                    let getTokenResult = await getUserActivationTokenResult()
                    // console.log(getTokenResult)
                    if (getTokenResult !== undefined || getTokenResult !== null) {
                        if (getTokenResult.data['supportSiteUserActivationCheckToken']['message'] !== undefined) {
                            console.log(getTokenResult.data['supportSiteUserActivationCheckToken']['message'])
                            setDisplay("activationError");
                        }
                        else {
                            updateLoginUrl(getTokenResult.data['supportSiteUserActivationCheckToken']['returnToURL'])
                            setDisplay("accountActivated");
                        }
                    }
                    else {
                        console.log(getTokenResult)
                        setDisplay("activationError");
                    }
                }
                else{
                    console.log("no token found");
                    setDisplay("noResourceFound");
                }
                setMountReadOnce("visited");
            }
        }
        async function getUserActivationTokenResult() {
            return await getQueryResult(getUserActivationToken(), {"token": token})
        }
        fetchData()
    }, [mountReadOnce, token, setMountReadOnce, setDisplay, updateLoginUrl]);

    let loadContent = null
    if (display === "noResourceFound") {
        loadContent = <ResourceNotFound />
    }
    if (display === "accountActivated") {
        loadContent = <AccountActivatedForm />
    }
    if (display === "activationError") {
        loadContent = <ActivationErrorForm />
    }
    return (
        <React.Fragment>
            {loadContent}
        </React.Fragment>
    )
}

export default UserActivationLandingPage;

